import { render, staticRenderFns } from "./ForumSections.vue?vue&type=template&id=82167b18&"
import script from "./ForumSections.vue?vue&type=script&lang=js&"
export * from "./ForumSections.vue?vue&type=script&lang=js&"
import style0 from "./ForumSections.vue?vue&type=style&index=0&id=82167b18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports